import "./js/algolia.js";
import "./scss/algolia.scss";
